/**
 * Retorna a forma abreviada.
 *
 * C = Preenchimento Obrigatório
 *
 * S = Ausência Obrigatória
 *
 * O = Opcional
 */
const abreviar = {
	'Preenchimento Obrigatório': 'C',
	'Ausência Obrigatória': 'S',
	Opcional: 'O',
}

/**
 * Retorna a forma desabreviada
 *
 * C = Preenchimento Obrigatório
 *
 * S = Ausência Obrigatória
 *
 * O = Opcional
 */
const desabreviar = {
	C: 'Preenchimento Obrigatório',
	S: 'Ausência Obrigatória',
	O: 'Opcional',
}

export { abreviar, desabreviar }
